import { createContext, useContext } from 'react';

export interface OrganizationColorProviderState {
	colors: Record<string, string>;
}

export const ColorProviderContext = createContext<OrganizationColorProviderState | undefined>({
	colors: {},
});

export const useOrganizationColors = () => {
	const context = useContext(ColorProviderContext);
	if (!context) {
		throw new Error('useOrganizationColors must be used within an OrganizationColorProvider');
	}
	return context.colors;
};
